import { a as __makeTemplateObject, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { rankWith, isAnyOfControl } from '@jsonforms/core';
import { withJsonFormsMultiEnumProps } from '@jsonforms/react';
import { useState } from 'react';
import { i as iconToComponentMap, t as tradeNameToIdMap } from './shared-81439ea7.js';
import { P as PillGroupStyled, T as TradeIconStyled } from './shared-e6e31491.js';
import styled, { css } from 'styled-components';
import { d as descriptionCapsize, h as headingLowerCapsize } from './typography-fe8ea2dd.js';
import { A as Accordion } from './Accordion-9fda376d.js';
import { C as CheckBox } from './CheckBox-9e58ea4a.js';
import { S as SimpleMarkdown } from './SimpleMarkdown-107c346a.js';

var FLEX_BOX_GAP_SIZE = 18;
var Description = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  margin: 0;\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 0;\n\n  ", "\n"])), descriptionCapsize, function (_a) {
    var theme = _a.theme;
    return "\n    color: " + theme.bottomForegroundPrimary + ";\n  ";
});
var JsonFormsAnyOfControlContainer = styled.section(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n  margin: 0;\n  padding: 0;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", "px;\n  margin: 0;\n  padding: 0;\n"])), FLEX_BOX_GAP_SIZE);
var SubheadLayout = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n"], ["\n  align-items: center;\n  display: grid;\n  grid-column-gap: 9px;\n  grid-template-columns: auto auto;\n  justify-content: flex-start;\n"])));
var Subhead = styled.h2(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", ";\n\n  margin: 0;\n  padding: 0;\n  text-align: left;\n\n  ", "\n"], ["\n  ", ";\n\n  margin: 0;\n  padding: 0;\n  text-align: left;\n\n  ", "\n"])), headingLowerCapsize, function (_a) {
    var theme = _a.theme;
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme.bottomForegroundPrimary);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

var jsonFormsAnyOfControlTester = rankWith(3, isAnyOfControl);
/**
 * AnyOf Control to be used as a renderer in the `JsonForms` component.
 *
 * @example
 *
 * <JsonForms
 *   renderers={[
 *     {
 *       renderer: JsonFormsAnyOfControl,
 *       tester: jsonFormsAnyOfControlTester,
 *     },
 *   ]}
 * ></JsonForms>
 */
var JsonFormsAnyOfControl = withJsonFormsMultiEnumProps(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var addItem = _a.addItem, data = _a.data, enabled = _a.enabled, path = _a.path, removeItem = _a.removeItem, schema = _a.schema, uischema = _a.uischema, visible = _a.visible;
    var _h = useState(true), isAccordionCollapsed = _h[0], setIsAccordionCollapsed = _h[1];
    var align = (_b = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _b === void 0 ? void 0 : _b.align;
    var title = (_c = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _c === void 0 ? void 0 : _c.title;
    var description = (_d = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _d === void 0 ? void 0 : _d.description;
    var format = (_e = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _e === void 0 ? void 0 : _e.format;
    var icon = (_f = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _f === void 0 ? void 0 : _f.icon;
    var IconComponent = iconToComponentMap[icon];
    var tradeName = (_g = uischema === null || uischema === void 0 ? void 0 : uischema.options) === null || _g === void 0 ? void 0 : _g.accordionIcon;
    var tradeId = tradeNameToIdMap[tradeName];
    var isAccordion = format === 'accordion';
    var isRadioButton = format === 'radio';
    var isPill = format === 'pill';
    var PillGroupComponent = (jsx(Fragment, { children: jsx(PillGroupStyled, { align: align, onChange: function (event) {
                if (enabled) {
                    if (typeof data === 'undefined' ||
                        (data && data.indexOf(event.currentTarget.value)) === -1) {
                        addItem(path, event.currentTarget.value);
                    }
                    else if (removeItem) {
                        removeItem(path, event.currentTarget.value);
                    }
                }
            }, options: schema && schema.anyOf
                ? schema.anyOf.map(function (ele, index) {
                    return {
                        key: "" + index,
                        label: ele.title,
                        value: "" + ele.const,
                    };
                })
                : [], size: "small", value: data }, void 0) }, void 0));
    var accordionStyle = function () {
        return (jsx(Fragment, { children: jsx(Accordion, { body: PillGroupComponent, header: jsxs(Fragment, { children: [jsx(TradeIconStyled, { tradeId: tradeId }, void 0), title] }, void 0), isCollapsed: isAccordionCollapsed, onClick: function () {
                    setIsAccordionCollapsed(!isAccordionCollapsed);
                } }, void 0) }, void 0));
    };
    var pillStyle = function () {
        return (jsxs(Fragment, { children: [title && (jsxs(SubheadLayout, { children: [IconComponent ? jsx(IconComponent, {}, void 0) : null, jsx(Subhead, { children: title }, void 0)] }, void 0)), PillGroupComponent] }, void 0));
    };
    var radioButtonStyle = function () {
        return (jsxs(Fragment, { children: [title && (jsxs(SubheadLayout, { children: [IconComponent ? jsx(IconComponent, {}, void 0) : null, jsx(Subhead, { children: title }, void 0)] }, void 0)), schema &&
                    schema.anyOf &&
                    schema.anyOf.map(function (ele, index) {
                        return (jsx(CheckBox, __assign({ onChange: function (event) {
                                if (enabled) {
                                    if (typeof data === 'undefined' ||
                                        (data && data.indexOf(event.currentTarget.value)) === -1) {
                                        addItem(path, event.currentTarget.value);
                                    }
                                    else if (removeItem) {
                                        removeItem(path, event.currentTarget.value);
                                    }
                                }
                            }, value: ele.const }, { children: ele.title }), index));
                    })] }, void 0));
    };
    if (!visible) {
        return null;
    }
    return (jsxs(JsonFormsAnyOfControlContainer, { children: [isAccordion && accordionStyle(), isPill && pillStyle(), isRadioButton && radioButtonStyle(), description && (jsx(Description, { children: jsx(SimpleMarkdown, { children: description }, void 0) }, void 0))] }, void 0));
});

export { JsonFormsAnyOfControl as J, jsonFormsAnyOfControlTester as j };
